{
    "CX_Score_Licences_None": "Keiner",
    "CX_Score_Licences_CXSScore": "Nur CX-Score",
    "CX_Score_Licences_CXSAgent": "CXS-Agent",
    "CX_Score_Licences_CXSManager": "CXS-Manager",
    "CX_Score_Agent_Error": "Für ein {} Abonnement wird ein Agent benötigt.",
    "NAME": "CXScoreLanguage"
}